import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectGradingConfig from "./routes/SubjectGradingConfig";

export default store => ({
  path: "grading-configurations",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "course-grading-configurations" */ "./components"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [SubjectGradingConfig(store)],
});
